import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Box, CircularProgress } from "@mui/material";
import { FC } from "react";
import type { ThemeV2 } from "../../../util/types";

type ProgressIndicatorProps = {
  showProgress: boolean;
  progress?: number;
  color: string;
  backgroundColor?: string;
  floating?: boolean;
  surveyTheme: ThemeV2;
};

export const ProgressIndicator: FC<ProgressIndicatorProps> = (props) => {
  const {
    showProgress,
    progress,
    color,
    backgroundColor,
    floating = false,
    surveyTheme,
  } = props;
  if (!showProgress || progress === undefined || !Number.isFinite(progress)) {
    return null;
  }

  const value = Math.min(100, Math.max(0, progress * 100));
  const isComplete = value === 100;
  const ringSize = floating ? 36 : 30;

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: floating ? backgroundColor : "transparent",
        borderRadius: `${surveyTheme.tokens.shape.radius.pill}px`,
        boxShadow: floating ? surveyTheme.tokens.elevation["2"] : "none",
        display: "inline-flex",
        flexShrink: 0,
        height: floating ? 48 : ringSize,
        justifyContent: "center",
        position: "relative",
        width: floating ? 48 : ringSize,
      }}
    >
      <CircularProgress
        aria-hidden="true"
        size={ringSize}
        sx={{ color, opacity: 0.28, position: "absolute" }}
        variant="determinate"
        thickness={5}
        value={100}
      />
      <CircularProgress
        aria-label={surveyTheme.copy.labels.surveyProgress}
        size={ringSize}
        sx={{ color, position: "absolute" }}
        variant="determinate"
        thickness={5}
        value={value}
      />
      {isComplete && (
        <CheckRoundedIcon
          aria-hidden="true"
          sx={{ color, fontSize: floating ? 22 : 24, position: "absolute" }}
        />
      )}
    </Box>
  );
};
